module.exports = __webpack_public_path__ + "static/img/header.acb73ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.jpg
// module id = Y5I1
// module chunks = 0